<template>
  <ErrorPage v-if="isErrorPage" :error="pageError" />
  <component v-else :is="currentLayout" />
</template>

<script>
import { mapState } from 'vuex'
import DefaultLayout from '../layouts/default.vue'
import MobileLayout from '../layouts/mobile.vue'
import ErrorPage from '../layouts/error.vue'
import { visibilitychangeFun } from './utils/verChange'

export default {
  name: 'App',
  components: {
    DefaultLayout,
    MobileLayout,
    ErrorPage,
  },
  computed: {
    ...mapState(['layout']),
    isErrorPage() {
      return this.$route.name === 'error'
    },
    pageError() {
      const q = this.$route.query
      return {
        statusCode: Number(q.statusCode) || 500,
        message: q.message || '',
      }
    },
    currentLayout() {
      return this.layout === 'mobile' ? 'MobileLayout' : 'DefaultLayout'
    },
  },
  created() {
    this.deferBootData()
    this.deferVersionCheck()
    console.log('NODE_ENV', process.env.NODE_ENV)
  },
  methods: {
    deferBootData() {
      const run = () =>
        this.$store.dispatch('init', { $api: this.$api }).catch((e) => {
          console.error('App init failed', e)
        })
      if (document.readyState === 'complete') {
        setTimeout(run, 1500)
      } else {
        window.addEventListener(
          'load',
          () => {
            setTimeout(run, 1500)
          },
          { once: true }
        )
      }
    },
    deferVersionCheck() {
      const start = () => visibilitychangeFun(() => window.location.reload(true))
      const run = () => setTimeout(start, 5000)
      if (document.readyState === 'complete') {
        run()
      } else {
        window.addEventListener('load', run, { once: true })
      }
    },
  },
}
</script>
